import { forwardRef, PropsWithChildren } from 'react'
import { FlexBox } from '../FlexBox'
import { AsComponentProp, NativeProps } from '../types'
import { Sprinkles } from '../../theme/sprinkles.css'

type Props = PropsWithChildren<
	NativeProps &
		AsComponentProp &
		Omit<
			Sprinkles,
			| 'flexDirection'
			| 'paddingTop'
			| 'paddingBottom'
			| 'paddingLeft'
			| 'paddingRight'
			| 'padding'
			| 'paddingX'
			| 'paddingY'
		>
>

export const Stack = forwardRef<HTMLElement, Props>(({ children, direction, ...rest }, ref) => {
	return (
		<FlexBox ref={ref} flexDirection={direction || 'column'} {...rest}>
			{children}
		</FlexBox>
	)
})
